import ProductImage from "../OBJRep/ProductImage";
import ResourceSearchResult from "../OBJRep/ResourceSearchResult";
import { PRODUCT_CATEGORY } from "./ResourcesService";
import { normalizeQuery, toDataURL } from "./Utils";
const storage = window.localStorage;
export const searchProductImages = async (query, token, page, userEmail) => {
  let images = [];
  const searchResult = await searchVpsProductImages(
    query,
    token,
    page,
    userEmail
  );
  images = searchResult.resources;
  if (!searchResult.isExactMatch) {
    const googleImages = await searchGoogleProductImages(
      query,
      token,
      page * 8
    );

    images = images.concat(googleImages);
    searchResult.resources = images;
  }
  return searchResult;
};

const searchGoogleProductImages = async (query, token, startsAt) => {
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  const cache = loadCachedImages(query);
  if (cache && cache.length >= startsAt) return cache;
  const q = query.replaceAll(" ", "+");
  const url = `${BASE_URL}custom-search/${q}?starts-at=${
    startsAt ? startsAt : 1
  }`;
  const res = await fetch(url, { headers: { Authorization: token } });
  const json = await res.json();
  const items = json.items;
  cacheImages(query, items);
  return items.map((item) => ProductImage(item.link, item.link));
};
//TODO:Migrate to ResourceService.js
const searchVpsProductImages = async (query, token, page, userEmail) => {
  const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", 8);
  params.append("query", query);
  params.append("userEmail", userEmail);
  const url = `${BASE_URL}/products/search?` + params.toString();
  const res = await fetch(url, {
    headers: { Authorization: token },
  });

  if (res.ok) {
    const json = await res.json();
    const images = (
      await Promise.all(
        json.resources.map(async (i) => {
          const link = await toDataURL(i.location + "/", token);
          return link ? ProductImage(i.location + "/", link) : null;
        })
      )
    ).filter((img) => img !== null);
    return ResourceSearchResult(
      images,
      json.isExactMatch,
      json.currentPage,
      json.hasNextPage
    );
  } else {
    console.error("Error fetching product images:", res.statusText);
    return ResourceSearchResult([], false, 0, false);
  }
};

const cacheImages = (q, images) => {
  q = normalizeQuery(q);
  let cache = [];
  let queryCached = false;
  const item = JSON.parse(storage.getItem("imagesCache"));
  if (item) cache = item;
  cache.forEach((e) => {
    if (e.q === q) {
      queryCached = true;
      e.images = images;
    }
  });
  if (queryCached) return;
  cache.push({
    q: q,
    images: images,
    //Expires in 7 days
    exp: new Date(Date.now() + 604800000).getTime(),
  });
  try {
    storage.setItem("imagesCache", JSON.stringify(cache));
  } catch (e) {
    cache = [];
    cache.forEach((el) => {
      if (el.exp > new Date().getTime()) cache.push(el);
    });
    storage.setItem("imagesCache", JSON.stringify(cache));
  }
};

const loadCachedImages = (query) => {
  query = normalizeQuery(query);
  const cache = storage.getItem("imagesCache");
  const array = JSON.parse(cache);
  let images;
  if (array)
    array.forEach((el) => {
      if (el.q === query) {
        images = el.images;
        el.exp = new Date(Date.now() + 604800000).getTime();
      }
    });
  storage.setItem("imagesCache", JSON.stringify(array));
  if (images)
    return images.map((image) => ProductImage(image.link, image.link));
};

/**
 * Persists user images by uploading them to the backend.
 * @param {File} file - File object to upload
 * @param {string} token - Auth token
 * @param {string} userEmail - User's email
 * @param {string} tags - Tags for the images (comma separated)
 * @returns {Promise<string[]>} - Array of uploaded image locations
 */
export async function persistUploadedImages(file, token, userEmail, tags = "") {
  const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
  const formData = new FormData();
  formData.append("files", file);
  formData.append("userEmail", userEmail);
  formData.append("tags", tags);
  formData.append("temporary", true);

  const res = await fetch(`${BASE_URL}/products`, {
    method: "POST",
    headers: {
      Authorization: token,
      "X-Access-Type": "API",
    },
    body: formData,
  });

  if (!res.ok) {
    throw new Error("Failed to upload image.");
  }

  const location = await res.text();
  const link = await toDataURL(location + "/", token);
  return ProductImage(location, link);
}
